import axios from 'util/axiosConfig';

export const getAllSites = async () => {
    return await axios.get(`/api/v1/admin/sites`)
        .then(function (response) {
            if (response.data) {
                return { success: true, sites: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}